import { render } from "./ViewingHistories.vue?vue&type=template&id=3718785a&scoped=true"
import script from "./ViewingHistories.vue?vue&type=script&lang=js"
export * from "./ViewingHistories.vue?vue&type=script&lang=js"

import "./ViewingHistories.scss?vue&type=style&index=0&id=3718785a&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3718785a"]])

export default __exports__